import { render, staticRenderFns } from "./iconblick.vue?vue&type=template&id=1d7ec2f1&scoped=true"
import script from "./iconblick.vue?vue&type=script&lang=js"
export * from "./iconblick.vue?vue&type=script&lang=js"
import style0 from "./iconblick.vue?vue&type=style&index=0&id=1d7ec2f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ec2f1",
  null
  
)

export default component.exports